import { Component } from '@angular/core';
import { VersionHistoryList } from './versionHistoryList.component.js';

@Component({
  selector: 'app-version-history',
  templateUrl: './version-history.component.html',
  styleUrls: ['./version-history.component.scss']
})
export class VersionHistoryComponent {
  versionHistoryList = VersionHistoryList;

  constructor() { }

}
